
export const SOFTLINE_SETTINGS_HTML5_SCANNER = 'html5Scanner';
